import { __extends, __values } from "tslib";
import { PayloadTransport } from '@magic-sdk/provider';
var WebTransport = /** @class */ (function (_super) {
    __extends(WebTransport, _super);
    function WebTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Initialize the underlying `Window.onmessage` event listener.
     */
    WebTransport.prototype.init = function () {
        var _this = this;
        window.addEventListener('message', function (event) {
            var e_1, _a;
            var _b;
            if (event.origin === _this.endpoint) {
                if (event.data && event.data.msgType && _this.messageHandlers.size) {
                    // If the response object is undefined, we ensure it's at least an
                    // empty object before passing to the event listener.
                    /* eslint-disable-next-line no-param-reassign */
                    event.data.response = (_b = event.data.response) !== null && _b !== void 0 ? _b : {};
                    try {
                        for (var _c = __values(_this.messageHandlers.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var handler = _d.value;
                            handler(event);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            }
        });
    };
    return WebTransport;
}(PayloadTransport));
export { WebTransport };
//# sourceMappingURL=web-transport.js.map